const a = "af.search-bar.visual-search", s = class s extends CustomEvent {
  constructor() {
    super(a, { bubbles: !0, composed: !0 });
  }
};
s.EVENT_NAME = a;
let e = s;
export {
  a as EVENT_NAME,
  e as default
};
//# sourceMappingURL=VisualSearchEvent.js.map
